export function getPrice(price) {
    if (price % 1 !== 0) {
        return (Math.round(price * 100) / 100).toFixed(2);
    } else {
        return price;
    }
}



// WEBPACK FOOTER //
// ./scripts/util/price.js